import React from "react";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { JobPositionFormTrainComponent } from "../../../components/borrowSystem/BorrowForm/JobPositionFormTrainComponent";
import { Footer } from "../../../components/share/Footer";

export function JobPositionFormTrainContainer() {
  const titleName =
    "รายละเอียดการขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพื่อดำเนินการฝึกอบรม";

  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <JobPositionFormTrainComponent />
      <Footer />
    </div>
  );
}
